import React, { useMemo, useState, useEffect } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard, FaBuilding, FaAddressCard } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, TextFieldIcon, SelectFieldIcon } from '../_components'
import Table from '../_components/Table'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'
import { values } from 'lodash'


export default function AssignedUsers( ) {
    const ActionField = ( record ) => {
        return (
          <div onClick={async () => {
            console.log("clicked record is below")
            console.log(record.value)
            await localStorage.setItem( "assignedDetailsFor", record.value )
            assignedUserDetailsSearch()
            await localStorage.setItem( "link", "assigned_users_details" )
            //return window.location.reload()
          } } className="cursor-pointer w-auto md:w-20 lg:w-48 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View Applications`}
          </div>
        )
    }

    const assignedUserColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Staff",
        accessor: "email_address"
        },
        {
        Header: "Number of Applications",
        accessor: "no_of_apps"
        },
        {
        Header: "Action",
        accessor: "staff_email",
        Cell: ActionField
        }
    ])

    const assignedUserDetailsColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Applicant",
        accessor: "applicant"
        },
        {
        Header: "Annual Income",
        accessor: "annual_income"
        },
        {
        Header: "Applicant Email",
        accessor: "applicant_email",
        }
        ,
        {
        Header: "Created On",
        accessor: "created_date",
        }
    ])
    
    const [ assignedUserRecords, setAssignedUserRecords ] = useState( [] )
    const [ assignedUserDetailsRecords, setAssignedUserDetailsRecords ] = useState( [] )
    const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )

    React.useEffect( () => {
        if( loading ) {
            fetchApplications()
        }
    },[ loading ])

    const fetchApplications = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
            if( response.data ) {
                const results = response.data.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.created_by,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.status?.toUpperCase() !== "APPROVED"
                } )

                //update the state
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {
            alert( "Server error occurred." )
            setLoading( false )
        }
    }

    const handleAssignedUsersSearch = async (values) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/search_assigned_users`, {
                from_date: values.from_date,
                to_date: values.to_date
            } )
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        email_address: result.assigned_auditor,
                        no_of_apps: result.count,
                        staff_email: result.assigned_auditor
                    }
                } ).filter( record => { 
                    return record.email_address !== null
                } )

                //update the state
                setAssignedUserRecords( results )
                setLoading( false )
            }
        } catch (error) {}
    }

    const assignedUserDetailsSearch = async () => {

        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/assigned_users_details/`+ localStorage.getItem( "assignedDetailsFor") )
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        applicant_email: result.created_by,
                        created_date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.status?.toUpperCase() !== "APPROVED"
                } )

                //update the state
                setAssignedUserDetailsRecords( results )
                setLoading( false )
            }
        } catch (error) {}
    }

    if( localStorage.getItem( "link" ) === "assigned_users_to_applications" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 bg-white text-[#AFC836] font-bold text-lg">
                        {`Assigned Users`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">
                            <Formik initialValues={{
                                from_date: values.from_date,
                                to_date: values.to_date,

                                }} onSubmit={handleAssignedUsersSearch}>
                                { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex row px-5">
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <div className="w-full pt-8 grid grid-cols-1">
                                                            <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                            </Formik>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={assignedUserColumns}
                            data={assignedUserRecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }


    if( localStorage.getItem( "link" ) === "assigned_users_details" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Applications assigned to `+localStorage.getItem( "assignedDetailsFor")}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">
                        <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={assignedUserDetailsColumns}
                            data={assignedUserDetailsRecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }
}